import React from 'react';
import { HbrIcon, HbrButton } from '@harbor/elements-react-standalone';
import { user } from '@harbor/elements/icons';

const styles = {
  menuItem: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    padding: 14,
    whiteSpace: 'nowrap',
  } as React.CSSProperties,
  prefix: {
    flex: '0 0 20px',
    width: 20,
    height: 20,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'var(--hbr-color-neutral-icon, #7E868F)',
  } as React.CSSProperties,
  menuBody: {
    flex: '1 1 auto',
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    minWidth: 0,
  } as React.CSSProperties,
  heading: {
    fontSize: 14,
    color: '#596069',
  } as React.CSSProperties,
  labelBold: {
    fontWeight: 600,
    fontSize: 'var(--hbr-font-size-sm, 14px)',
    color: 'black',
    lineHeight: '20px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  } as React.CSSProperties,
  suffix: {
    flex: '0 0 auto',
    display: 'flex',
    alignItems: 'center',
  } as React.CSSProperties,
};

const UserProfileInfoSection: React.FC<{
  email: string | null;
  logout: () => void;
}> = ({ email, logout }) => (
  <div style={styles.menuItem}>
    <div style={styles.prefix}>
      <HbrIcon asset={user} style={{ fontSize: 20 }} />
    </div>

    <div style={styles.menuBody}>
      <div style={styles.heading}>Logged in as</div>
      <div style={styles.labelBold}>{email}</div>
    </div>

    <HbrButton
      style={styles.suffix}
      variant="outline"
      onClick={logout}
    >
      Log Out
    </HbrButton>
  </div>
);

export default UserProfileInfoSection;